import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver } from '@angular/cdk/layout';

@Injectable({
  providedIn: 'root'
})
export class ModalDialogService {

  private dialog = inject(MatDialog);
  private breakpointObserver = inject(BreakpointObserver);

  showComponent(component: any, data: any = {}, width = 840, disableClose = true) {
    const isLargeScreen = this.breakpointObserver.isMatched('(min-width: 540px)');
    const dialogWidth = !isLargeScreen ? '100%' :  width + 'px' ;

    return this.dialog.open(component, {
      data,
      panelClass: isLargeScreen ? '' : 'my-custom-dialog',
      width: dialogWidth,
      autoFocus: false,
      disableClose: disableClose
    })
    .afterClosed();
  }

}
